import { useFetchRecommendations } from '@hooks/useFetchRecommendations';
import { getVendorsFromLocalStorage } from '@pages/Storefront/helpers/recentlyViewedVendors';
import { useAppSelector } from '@redux/hooks';
import { similarAlgorithmType } from '@redux/widget/actions';
import React, { type FC } from 'react';
import { connect } from 'react-redux';
import type { Category } from 'types/redux';
import { PVRecWidget } from '../../../../containers/widget';
import algorithms from '../../../../containers/widget/constants/algorithms';
import Styles from './styles.scss';

export type RightRailProps = ReturnType<typeof mapStateToProps>;

const RightRail: FC<RightRailProps> = (props) => {
	const { location, marketCode } = props;
	const similarVendorsBasedOnActivityReducer = useAppSelector(
		(state) => state.widget.similarVendorsBasedOnActivityReducer,
	);
	const category = useAppSelector((state) => state.category);

	// Fetch pvRec recommendations (member and anonymous) on client side
	useFetchRecommendations();

	const algorithmType = getSelectedAlgorithmType(
		similarVendorsBasedOnActivityReducer,
	);
	const headerText = getHeaderText(
		similarVendorsBasedOnActivityReducer,
		category,
	);

	return (
		<div className={Styles.rightRailSticky}>
			<div className={Styles.rightRailColumn}>
				<PVRecWidget
					algorithmType={algorithmType}
					cardType="sm"
					location={location}
					marketCode={marketCode}
					className={Styles.rightRailWidget}
					headerText={headerText}
				/>
			</div>
			<div className={Styles.rightRailBottom} />
		</div>
	);
};

const getHeaderText = (
	similarVendorsBasedOnActivityReducer: Redux.State['widget']['similarVendorsBasedOnActivityReducer'],
	category: Category,
): string => {
	if (similarVendorsBasedOnActivityReducer.isFetching) {
		const { vendorToFindSimilar } = similarVendorsBasedOnActivityReducer;

		if (vendorToFindSimilar) {
			if (
				similarVendorsBasedOnActivityReducer.vendorToFindSimilar
					?.similarAlgorithmType === similarAlgorithmType.LAST_LEAD
			) {
				return `Because you contacted ${vendorToFindSimilar.name}`;
			}

			if (
				similarVendorsBasedOnActivityReducer.vendorToFindSimilar
					?.similarAlgorithmType === similarAlgorithmType.LAST_SAVED
			) {
				return `Because you saved ${vendorToFindSimilar.name}`;
			}
		}
	}

	if (hasVisitedVendorsWithSameCategory(category)) {
		return `Based on ${category.name} you’ve explored`;
	}

	return '';
};

const getSelectedAlgorithmType = (
	similarVendorsBasedOnActivityReducer: Redux.State['widget']['similarVendorsBasedOnActivityReducer'],
) => {
	return similarVendorsBasedOnActivityReducer.isFetching
		? algorithms.SIMILAR_ROS
		: algorithms.PAIVER_ROS;
};

const hasVisitedVendorsWithSameCategory = (category: Category): boolean => {
	const visitedVendors = getVendorsFromLocalStorage();

	if (visitedVendors === null) {
		return false;
	}

	const { code: categoryCode } = category;

	return visitedVendors.some(
		(visitedVendor) => visitedVendor.category === categoryCode,
	);
};

const mapStateToProps = (state: Redux.State) => ({
	location: state.location,
	marketCode: state.settings.marketCode,
});

export default connect(mapStateToProps)(RightRail);
